import {axios} from "@/api/config";
// 查询危险源管理列表
export function listPingram(params) {
    return axios.get(`/pingram/list`, params, true);
}

export function delPingram(id) {
    return axios.delete(`/pingram/${id}`, true)
}
// 查询危险源管理详细
export function getPingramById(id) {
    return axios.get(`/pingram/${id}`, id, true)
}